import { useBlockProps, RichText } from '@wordpress/block-editor';

export default function save(props) {
	const blockProps = useBlockProps.save({
		className: 'c4l-example',
	});

	const { attributes } = props;
	const { title, text } = attributes;

	return (
		<div {...blockProps}>
			<div className='c4l-example-content'>
				<RichText.Content
					tagName='h1'
					className='c4l-example-title'
					value={title}
				/>
				<RichText.Content
					tagName='div'
					className='c4l-example-text'
					value={text}
				/>
			</div>
		</div>
	);
}
